import { useContext } from 'react';
import { CookiesContext } from './CookiesProvider';

export const useCookies = () => useContext(CookiesContext);
